import React, { useState, useEffect } from 'react';
import './../App.css';
import ApiService from '../services/ApiService';
import YandexAdComponent from '../components/YandexAdComponent';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';
import AnimeRow from '../components/AnimeRow';

const CategoriesPage = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = 'animix - Категории';

        const fetchCategories = async () => {
            try {
                const catData = await ApiService.getPublicCategories();
                if (catData.type === "success") {
                    setCategories(catData.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    return (
        <PageShell sidebar className="catalog-page categories-page page-shell--bleed" mainClassName="feed">
            <PageHeader title="Категории" />
            <YandexAdComponent blockId="R-A-8131234-1" />
            {loading ? <p className="ui-status">Загружаем…</p> : null}
            {categories.map((category) => (
                <AnimeRow
                    key={category.id}
                    title={category.name}
                    items={category.animeList}
                    to={`/category/${category.id}`}
                />
            ))}
        </PageShell>
    );
};

export default CategoriesPage;
